import { showroomsAPI } from "@/views/Showrooms/api";

export const getShowrooms = async () => {
  try {
    const res = await showroomsAPI.getShowrooms();
    return res?.data;
  } catch (e) {}
};
export const getShowroomPhotos = async (front_show_room_id) => {
  try {
    const res = await showroomsAPI.getShowroomPhotos(front_show_room_id);
    return res?.data;
  } catch (e) {}
};
export const updShowroomPhoto = async (body) => {
  try {
    const res = await showroomsAPI.updShowroomPhoto(body);
    return res?.data;
  } catch (e) {}
};
export const deleteShowroomPhoto = async (front_show_room_photo_id) => {
  try {
    const res = await showroomsAPI.deleteShowroomPhoto(front_show_room_photo_id);
    return res?.data;
  } catch (e) {}
};

export const showroomsColumns = [
  {
    name: "i",
    label: "№",
    field: "i",
    align: "center",
  },
  {
    name: "city_name",
    label: "Город",
    field: "city_name",
    align: "center",
  },
  {
    name: "resident_name",
    label: "ЖК",
    field: "resident_name",
    align: "center",
  },
  {
    name: "address",
    label: "Адрес",
    field: "address",
    align: "center",
  },
  {
    name: "video_url",
    label: "Ссылка на видео",
    field: "video_url",
    align: "center",
  },
  {
    name: "order_num",
    label: "Порядковый номер",
    field: "order_num",
    align: "center",
  },
  // {
  //   name: "is_show_room",
  //   label: "Фото",
  //   field: "is_show_room",
  //   align: "center",
  // },
  {
    name: "is_remarket",
    label: "Ремаркет",
    field: "is_remarket",
    align: "center",
  },
  {
    name: "actions",
    label: "Фото",
    align: "center",
  },
];
export const shwrmPhotosColumns = [
  // {
  //   name: "front_show_room_photo_id",
  //   label: "ID",
  //   field: "front_show_room_photo_id",
  //   align: "center",
  // },
  {
    name: "i",
    label: "№",
    field: "i",
    align: "center",
    sortable: true,
  },
  {
    name: "photo_url_mini",
    label: "Фото",
    field: "photo_url_mini",
    align: "center",
  },
  {
    name: "is_active",
    label: "Активность",
    field: "is_active",
    align: "center",
    sortable: true,
  },
  {
    name: "is_main",
    label: "Главная фотка",
    field: "is_main",
    align: "center",
    sortable: true,
  },
  {
    name: "order_num",
    label: "Порядковый номер",
    field: "order_num",
    align: "center",
    sortable: true,
  },
  {
    name: "edt",
    label: "",
    align: "center",
  },
  {
    name: "dlt",
    label: "",
    align: "center",
  },
];
